import Vue from "vue";
import {
  Toast,
  Popup,
  Icon,
  Overlay,
  List,
  Tab,
  Tabs,
  DatetimePicker,
  Picker,
  Swipe,
  SwipeItem,
  Lazyload,
  ImagePreview,
  NoticeBar,
  Area,
  CountDown,
  PullRefresh,
  Dialog,
  Skeleton,
  ShareSheet,
  Field,
  RadioGroup, 
  Radio,
  Checkbox, 
  CheckboxGroup,
  Uploader,
  notify,
  Loading,
  Empty,
  ActionSheet,
  Popover,
  Switch,
  SwipeCell
} from "vant";

Vue.use(Toast)
  .use(Popup)
  .use(Icon)
  .use(Overlay)
  .use(List)
  .use(Tab)
  .use(Tabs)
  .use(DatetimePicker)
  .use(Picker)
  .use(Swipe)
  .use(SwipeItem)
  .use(Lazyload)
  .use(ImagePreview)
  .use(NoticeBar)
  .use(Area)
  .use(CountDown)
  .use(PullRefresh)
  .use(Dialog)
  .use(Skeleton)
  .use(ShareSheet)
  .use(Field)
  .use(Radio)
  .use(RadioGroup)
  .use(Checkbox)
  .use(CheckboxGroup)
  .use(Uploader)
  .use(notify)
  .use(Loading)
  .use(Empty)
  .use(ActionSheet)
  .use(Popover)
  .use(Switch)
  .use(SwipeCell)
  
Vue.prototype.$toast = Toast
Vue.prototype.$imagePreview = ImagePreview
Vue.prototype.$dialog = Dialog
Vue.prototype.$notify = notify



// WEBPACK FOOTER //
// ./src/assets/js/vant.js